import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { THEMES, ACCENTS } from "@/lib/card";

export const ThemeTab = ({ card, update }) => (
  <div className="space-y-6 rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
    <div>
      <h3 className="text-lg font-semibold">Personalizzazione Visuale</h3>
      <p className="mt-1 text-sm text-slate-500">Scegli il tema della scheda e il colore del tuo brand.</p>
    </div>
    <div className="grid grid-cols-2 gap-4">
      {Object.entries(THEMES).map(([id, t]) => (
        <button key={id} onClick={() => update({ theme: id })} data-testid={`theme-option-${id}`}
                className={`relative rounded-xl border-2 p-4 text-left transition-[transform,border-color] duration-200 hover:-translate-y-0.5 ${card.theme === id ? "border-blue-600" : "border-slate-200"}`}>
          <div className="h-16 rounded-lg" style={{ background: `linear-gradient(135deg, ${t.bg} 60%, ${t.surface})`, border: `1px solid ${t.border}` }} />
          <p className="mt-3 text-sm font-semibold">{t.name}</p>
          {card.theme === id && <Check size={16} className="absolute right-3 top-3 text-blue-600" />}
        </button>
      ))}
    </div>
    <div className="space-y-3">
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Colore accento</Label>
      <div className="flex flex-wrap items-center gap-3">
        {ACCENTS.map((c) => (
          <button key={c} onClick={() => update({ accent: c })} aria-label={c} data-testid={`accent-${c.slice(1)}`}
                  className={`h-9 w-9 rounded-full border-2 transition-transform hover:scale-110 ${card.accent === c ? "border-slate-900 ring-2 ring-offset-2 ring-slate-900" : "border-slate-200"}`}
                  style={{ background: c }} />
        ))}
        <Input type="color" value={card.accent} onChange={(e) => update({ accent: e.target.value })} data-testid="input-accent-custom" className="h-9 w-14 cursor-pointer p-1" />
      </div>
    </div>
  </div>
);
